import MixingFunctions from '../components/MixingFunctions';
import PartinerList from '../components/PartinerList';
import GridItens from '../components/template2/GridItens';

new Vue({
    el: '#main-content',
    mixins: [
        MixingFunctions
    ],
    components: {
        'stretch': VueLoadingSpinner.Stretch,
        PartinerList,
        GridItens
    },
    data: {
        baseLink: window.vueData.baseLink,
        storage: window.vueData.storage,
        corLoading: window.vueData.corLoading,
        loading: true,
        itens: window.vueData.itens,
        marca: window.vueData.marca,
        categoria: window.vueData.categoria,
        marcasEspeciais: window.vueData.marcasEspeciais,
        bannersLateral: window.vueData.bannersLateral
    },
    methods: {
        // goToLink (item) {
        //     if (item.link !== '') {
        //         document.location.href = item.link;
        //     }
        // },
        goTo (slug) {
            document.location.href = '/loja/' + slug;
        }
    }
});
